import { Injectable } from '@angular/core';
import { ShellDomainProvider } from '../utility/shell-domain.provider';

// @dynamic
@Injectable()
export class CommonTranslationService {
    public static lastLanguage;
    public static translation;

    constructor() {}

    setCommonLanguage(translation) {
        CommonTranslationService.translation = translation;
    }

    setLastLanguage(lastLanguage) {
        CommonTranslationService.lastLanguage = lastLanguage;
    }
}

export interface ITranslationResource {
    prefix: string;
    suffix: string;
}

export class TranslationResourceModel {
    prefix = '';
    suffix = '';

    constructor(prefix: string) {
        const useBlocksUilm = ShellDomainProvider['api'].UseBlocksUilm;
        const blocksClientId = ShellDomainProvider['api'].BlocksClientId;

        if(useBlocksUilm) {
            this.prefix = `${ShellDomainProvider['api'].BlocksUilmService}GetUilmFile?ModuleName=${prefix}&OId=${blocksClientId}&Language=`
        }
        else this.prefix = `${ShellDomainProvider['api'].UilmService}/Query/GetUilmFile?ModuleName=${prefix}&Language=`;
    }
}